<template>
  <div class="d-md-flex flex-column flex-lg-row justify-content-between mt-3 mb-3">
    <div class="th-acc-left mt-3">
      <div class="d-flex flex-column flex-lg-row th-info">
        <div class="col-12 col-md-5">
          <h4 class="h-100">
            Room Category
          </h4>
        </div>
        <div class="col-12 col-md-7">
          <p>{{ accommodationItem.roomType ? accommodationItem.roomType.toUpperCase() : 'N/A' }}</p> 
        </div>   
      </div>
      <div class="col-12 col-md-11">
        <hr class="m-0">
      </div>
      <div class="d-flex flex-column flex-lg-row th-info">
        <div class="col-12 col-md-5">
          <h4>Room Configuration</h4>
        </div>
        <div class="col-12 col-md-7"> 
          <p>{{ accommodationItem.roomSize ? `${accommodationItem.roomSize.toUpperCase()} OCCUPANCY` : 'N/A' }}</p> 
        </div>  
      </div>
      <div class="col-12 col-md-11">
        <hr class="m-0">
      </div>
      <div class="d-flex flex-column flex-lg-row th-info">
        <div class="col-12 col-md-5">
          <h4>Board Basis</h4>
        </div>
        <div class="col-12 col-md-7">
          <p>{{ accommodationItem.boardBasis ? `${accommodationItem.boardBasis.toUpperCase()}` : 'N/A' }}</p> 
        </div>   
      </div>
      <div class="col-12 col-md-11">
        <hr class="m-0">
      </div>
      <div
        v-if="accommodationItem.supplements && accommodationItem.supplements.length"  
        class="d-flex flex-column flex-lg-row th-info"
      >
        <div class="col-12 col-md-5">
          <h4>Additional Inclusions</h4>
        </div>
        <div class="col-12 col-md-7">
          <p
            v-for="(supplement, supplementIndex) in accommodationItem.supplements"
            :key="`supplement-${supplementIndex}`"
          >
            {{ supplement.title }}
          </p>
        </div>    
      </div>
      <div 
        v-if="serviceTravellers"  
        class="d-flex flex-column flex-lg-row th-info"
      >
        <div class="col-12 col-md-5">
          <h4>Reservation For</h4>
        </div>
        <div class="col-12 col-md-7">
          <p>{{ serviceTravellers }}</p>
        </div>    
      </div>
    </div>
    <div 
      class="th-acc-right"
    >
      <div 
        class="mr-lg-3 mb-5 mb-lg-0 w-100 gallery-button mt-2" 
        @click="(accommodationItem &&
          accommodationItem.media &&
          accommodationItem.media.images &&
          accommodationItem.media.images.length) ||
          accommodationItem.description ? handleOpenAccModal() : null"
      >
        <img
          v-if="accommodationItem && 
            accommodationItem.media && 
            accommodationItem.media.images &&
            accommodationItem.media.images.length" 
          :src="accommodationItem.media.images.length ? addCdnImageWidth(accommodationItem.media.images[0], 600) : 'https://images.unsplash.com/photo-1535262412227-85541e910204?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTV8fGJlYWNofGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60'"
          alt="accommmodation image"
          class="th-service-image"
        >
        <button
          v-if="(accommodationItem && 
            accommodationItem.media && 
            accommodationItem.media.images &&
            accommodationItem.media.images.length) || accommodationItem.description"
          class="w-100 m-0 th-button rounded text-center th-acc-btn mb-3"
          @click="handleOpenAccModal"
        >
          <span>{{ accommodationItem.title }} Information</span>
        </button>
      </div>
      <div>
        <button
          v-if="showAccEssInfoBtn"
          class="w-100 th-button rounded text-center th-ess-info-btn mb-3" 
          @click="handleOpenEssInfoAccModal"
        >
          Essential Accommodation Information
        </button>
      </div>
    </div>
    <AccommodationModal
      ref="accomodationModalRef"
      :accommodation-item="accommodationItem"
    />
    <EssentialInfoAccModal
      ref="essInfoAccModal"
      :additional-information="accommodationItem.additionalInfoExt"
      :custom-description="accommodationItem.customDescription"
      :date-range-messages="accommodationItem.dateRangeMessages"
      title="Essential Accommodation Information"
      :date="accommodationItem.groupdate"
      :supplements="accommodationItem.supplements"
    />
  </div>
</template>

<script>
import dayjs from '@/lib/dayjs'
import { outputTravellers } from '../utils'
import AccommodationModal from '../modals/accommodation-modal.vue'
import EssentialInfoAccModal from '../modals/essential-info-acc-modal.vue'
import { addCdnImageWidth } from '@/lib/utilities'
export default {
  components: {
    AccommodationModal,
    EssentialInfoAccModal
  },
  props: {
    accommodationItem: {
      type: Object
    },
    tourTravellers: {
      type: Array
    }
  },
  data () {
    return {
      serviceTravellers: false,
      showEssInfoModalFlag: false,
    }
  },
  computed: {
    showAccEssInfoBtn() {
      if (this.showEssInfoModalFlag || this.accommodationItem.additionalInfoExt !== '' || this.accommodationItem.customDescription !== '') {
        return true
      }
      return false
    }
  },
  mounted () {
    this.setReservationFor();
    this.checkDateRange();
  },
  methods: {
    addCdnImageWidth,
    checkDateRange () {
      this.showEssInfoModalFlag = false;
      const newDate = dayjs(new Date(this.accommodationItem.groupdate))
      if (this.accommodationItem) {
        if (this.accommodationItem.dateRangeMessages) {
          if (this.accommodationItem.dateRangeMessages.length >= 1) {
            this.accommodationItem.dateRangeMessages.forEach((message) => {
              const startDate = dayjs(new Date(message.dateFrom))
              const endDate = dayjs(new Date(message.dateTo))
              const isWithinRange = newDate.isBetween(startDate - 1, endDate + 1)
              if (isWithinRange) {
                this.showEssInfoModalFlag = true;
              }
            })
          }
        }
        // if no date range messages to show, then check if any supplement description exists AND whether the supplement falls witihin the date range 
        if (
          !this.showEssInfoModalFlag &&
          this.accommodationItem.supplements &&
          this.accommodationItem.supplements.length
        ) {
          this.accommodationItem.supplements.forEach((supp) => {
            if (!supp.description || !supp.description.trim()){
              // no description so no further checks required
              return;
            }
            const startDate = dayjs(new Date(supp.dateFrom));
            const endDate = dayjs(new Date(supp.dateTo));
            const isWithinRange = newDate.isBetween(startDate - 1, endDate + 1);
            if (isWithinRange) {
              this.showEssInfoModalFlag = true;
            }
          });
        }
      }
    },
    setReservationFor () {
      if (this.tourTravellers.length === this.accommodationItem.travellers.length) {
        this.serviceTravellers = false
      } else {
        const travellers = this.accommodationItem.travellers
        this.serviceTravellers = outputTravellers(travellers)
      }
    },
    handleOpenAccModal () {
      this.$refs.accomodationModalRef.showModal()
    },
    handleOpenEssInfoAccModal () {
      this.$refs.essInfoAccModal.showModal()
    },
  }
}
  </script>
  
  <style lang="scss">
  @import "../../styles.scss";
  .item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-end {
    width: 300px;
  }
  .toggle {
    display: flex;
    justify-content: flex-end;
  }
  .th-acc-left {
    width: 100%;
  }
  .th-acc-right {
    width: 100%;
    padding-right: 15px;
  }
  .th-acc-btn {
    background-color: #96d184;
  }
  .th-ess-info-btn {
    background-color: #c2dbf2;
  }
  // .th-service-image {
  //   height: 300px;
  // }
  @media only screen and (min-width: 992px) {
    .th-acc-left {
    width: 60%;
  }
  .th-acc-right {
    width: 40%;
    padding-left: 15px;
    padding-right: 15px;
  }
  }
  </style>